/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseCreateAgreementsResponse } from '../models/ApiResponseCreateAgreementsResponse';
import type { ApiResponseDeleteAgreementsResponse } from '../models/ApiResponseDeleteAgreementsResponse';
import type { ApiResponseGetUbiThirdPartyAgreementsForServiceDevelopResponse } from '../models/ApiResponseGetUbiThirdPartyAgreementsForServiceDevelopResponse';
import type { ApiResponseListMyAppUbiThirdPartyAgreementsResponse } from '../models/ApiResponseListMyAppUbiThirdPartyAgreementsResponse';
import type { ApiResponseListUbiThirdPartyAgreementsResponse } from '../models/ApiResponseListUbiThirdPartyAgreementsResponse';
import type { ApiResponseObject } from '../models/ApiResponseObject';
import type { ApiResponseUpdateUbiThirdPartyAgreementsForServiceDevelopResponse } from '../models/ApiResponseUpdateUbiThirdPartyAgreementsForServiceDevelopResponse';
import type { CreateUbiThirdpartyAgreementsCommand } from '../models/CreateUbiThirdpartyAgreementsCommand';
import type { DeleteUbiThirdpartyAgreementsCommand } from '../models/DeleteUbiThirdpartyAgreementsCommand';
import type { UpdateUbiThirdPartyAgreementsForServiceDevelopCommand } from '../models/UpdateUbiThirdPartyAgreementsForServiceDevelopCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UbiThirdPartyAgreementsControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * UBI 보험사 제3자 제공동의 철회
   * MyApp을 위한 보험사 개인정보 동의 철회
   * @returns ApiResponseDeleteAgreementsResponse OK
   * @throws ApiError
   */
  public deleteMyAppAgreements({
    requestBody,
  }: {
    requestBody: DeleteUbiThirdpartyAgreementsCommand,
  }): CancelablePromise<ApiResponseDeleteAgreementsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/third-party/ubi/myapp/agreements/withdraw/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * UBI 보험사 제3자 제공동의 철회
   * MyApp을 위한 보험사 개인정보 동의 철회
   * @returns ApiResponseDeleteAgreementsResponse OK
   * @throws ApiError
   */
  public deleteMyAppAgreements1({
    requestBody,
  }: {
    requestBody: DeleteUbiThirdpartyAgreementsCommand,
  }): CancelablePromise<ApiResponseDeleteAgreementsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/third-party/ubi/myapp/agreements/withdraw',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * UBI 보험사 제3자 제공동의 조회
   * MyApp을 위한 보험사 개인정보 동의 조회 (리스트)
   * @returns ApiResponseListMyAppUbiThirdPartyAgreementsResponse OK
   * @throws ApiError
   */
  public listMyAppAgreements({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseListMyAppUbiThirdPartyAgreementsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/third-party/ubi/myapp/agreements',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * UBI 보험사 제3자 제공동의 (MyApp)
   * MyApp을 위한 보험사 개인정보 동의
   * @returns ApiResponseObject OK
   * @throws ApiError
   */
  public createMyAppAgreement({
    requestBody,
  }: {
    requestBody: CreateUbiThirdpartyAgreementsCommand,
  }): CancelablePromise<ApiResponseObject> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/third-party/ubi/myapp/agreements',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * UBI 보험사 제3자 제공동의 조회
   * MyApp을 위한 보험사 개인정보 동의 조회 (리스트)
   * @returns ApiResponseListMyAppUbiThirdPartyAgreementsResponse OK
   * @throws ApiError
   */
  public listMyAppAgreements1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseListMyAppUbiThirdPartyAgreementsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/third-party/ubi/myapp/agreements/',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * UBI 보험사 제3자 제공동의 (MyApp)
   * MyApp을 위한 보험사 개인정보 동의
   * @returns ApiResponseObject OK
   * @throws ApiError
   */
  public createMyAppAgreement1({
    requestBody,
  }: {
    requestBody: CreateUbiThirdpartyAgreementsCommand,
  }): CancelablePromise<ApiResponseObject> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/third-party/ubi/myapp/agreements/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * UBI 보험사 제3자 제공동의 철회
   * 상담센터를 위한 보험사 개인정보 동의 철회
   * @returns ApiResponseDeleteAgreementsResponse OK
   * @throws ApiError
   */
  public deleteAgreements({
    requestBody,
  }: {
    requestBody: DeleteUbiThirdpartyAgreementsCommand,
  }): CancelablePromise<ApiResponseDeleteAgreementsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/third-party/ubi/customer-service/agreements/withdraw/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * UBI 보험사 제3자 제공동의 철회
   * 상담센터를 위한 보험사 개인정보 동의 철회
   * @returns ApiResponseDeleteAgreementsResponse OK
   * @throws ApiError
   */
  public deleteAgreements1({
    requestBody,
  }: {
    requestBody: DeleteUbiThirdpartyAgreementsCommand,
  }): CancelablePromise<ApiResponseDeleteAgreementsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/third-party/ubi/customer-service/agreements/withdraw',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * UBI 보험사 제3자 제공동의 조회
   * 상담센터를 위한 보험사 개인정보 동의 조회 (리스트)
   * @returns ApiResponseListUbiThirdPartyAgreementsResponse OK
   * @throws ApiError
   */
  public listAgreements({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseListUbiThirdPartyAgreementsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/third-party/ubi/customer-service/agreements/',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * UBI 보험사 제3자 제공동의
   * 상담센터를 위한 보험사 개인정보 동의
   * @returns ApiResponseCreateAgreementsResponse OK
   * @throws ApiError
   */
  public createAgreements({
    requestBody,
  }: {
    requestBody: CreateUbiThirdpartyAgreementsCommand,
  }): CancelablePromise<ApiResponseCreateAgreementsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/third-party/ubi/customer-service/agreements/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * UBI 보험사 제3자 제공동의 조회
   * 상담센터를 위한 보험사 개인정보 동의 조회 (리스트)
   * @returns ApiResponseListUbiThirdPartyAgreementsResponse OK
   * @throws ApiError
   */
  public listAgreements1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseListUbiThirdPartyAgreementsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/third-party/ubi/customer-service/agreements',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * UBI 보험사 제3자 제공동의
   * 상담센터를 위한 보험사 개인정보 동의
   * @returns ApiResponseCreateAgreementsResponse OK
   * @throws ApiError
   */
  public createAgreements1({
    requestBody,
  }: {
    requestBody: CreateUbiThirdpartyAgreementsCommand,
  }): CancelablePromise<ApiResponseCreateAgreementsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/third-party/ubi/customer-service/agreements',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * UBI 보험사 제3자 제공동의 철회
   * Cci 위한 보험사 개인정보 동의 철회
   * @returns ApiResponseDeleteAgreementsResponse OK
   * @throws ApiError
   */
  public deleteCciAgreements({
    requestBody,
  }: {
    requestBody: DeleteUbiThirdpartyAgreementsCommand,
  }): CancelablePromise<ApiResponseDeleteAgreementsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/third-party/ubi/cci/agreements/withdraw',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * UBI 보험사 제3자 제공동의 철회
   * Cci 위한 보험사 개인정보 동의 철회
   * @returns ApiResponseDeleteAgreementsResponse OK
   * @throws ApiError
   */
  public deleteCciAgreements1({
    requestBody,
  }: {
    requestBody: DeleteUbiThirdpartyAgreementsCommand,
  }): CancelablePromise<ApiResponseDeleteAgreementsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/third-party/ubi/cci/agreements/withdraw/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 고도화 동의 업데이트
   * 고도화 동의 업데이트
   * @returns ApiResponseUpdateUbiThirdPartyAgreementsForServiceDevelopResponse OK
   * @throws ApiError
   */
  public updateAgreementsForSeviceDevelop({
    requestBody,
  }: {
    requestBody: UpdateUbiThirdPartyAgreementsForServiceDevelopCommand,
  }): CancelablePromise<ApiResponseUpdateUbiThirdPartyAgreementsForServiceDevelopResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/third-party/ubi/cci/agreements/for-service-develop/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 고도화 동의 조회
   * 고도화 동의 조회
   * @returns ApiResponseGetUbiThirdPartyAgreementsForServiceDevelopResponse OK
   * @throws ApiError
   */
  public getAgreementsForServiceDevelop1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetUbiThirdPartyAgreementsForServiceDevelopResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/third-party/ubi/cci/agreements/for-service-develop',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 고도화 동의 업데이트
   * 고도화 동의 업데이트
   * @returns ApiResponseUpdateUbiThirdPartyAgreementsForServiceDevelopResponse OK
   * @throws ApiError
   */
  public updateAgreementsForSeviceDevelop1({
    requestBody,
  }: {
    requestBody: UpdateUbiThirdPartyAgreementsForServiceDevelopCommand,
  }): CancelablePromise<ApiResponseUpdateUbiThirdPartyAgreementsForServiceDevelopResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/third-party/ubi/cci/agreements/for-service-develop',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * UBI 보험사 제3자 제공동의 조회
   * CCI를 위한 보험사 개인정보 동의 조회 (리스트)
   * @returns ApiResponseListUbiThirdPartyAgreementsResponse OK
   * @throws ApiError
   */
  public listCciAgreements({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseListUbiThirdPartyAgreementsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/third-party/ubi/cci/agreements',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * UBI 보험사 제3자 제공동의 (CCI)
   * CCI를 위한 보험사 개인정보 동의
   * @returns ApiResponseCreateAgreementsResponse OK
   * @throws ApiError
   */
  public createCciAgreement({
    requestBody,
  }: {
    requestBody: CreateUbiThirdpartyAgreementsCommand,
  }): CancelablePromise<ApiResponseCreateAgreementsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/third-party/ubi/cci/agreements',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * UBI 보험사 제3자 제공동의 조회
   * CCI를 위한 보험사 개인정보 동의 조회 (리스트)
   * @returns ApiResponseListUbiThirdPartyAgreementsResponse OK
   * @throws ApiError
   */
  public listCciAgreements1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseListUbiThirdPartyAgreementsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/third-party/ubi/cci/agreements/',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * UBI 보험사 제3자 제공동의 (CCI)
   * CCI를 위한 보험사 개인정보 동의
   * @returns ApiResponseCreateAgreementsResponse OK
   * @throws ApiError
   */
  public createCciAgreement1({
    requestBody,
  }: {
    requestBody: CreateUbiThirdpartyAgreementsCommand,
  }): CancelablePromise<ApiResponseCreateAgreementsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/third-party/ubi/cci/agreements/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 고도화 동의 조회
   * 고도화 동의 조회
   * @returns ApiResponseGetUbiThirdPartyAgreementsForServiceDevelopResponse OK
   * @throws ApiError
   */
  public getAgreementsForServiceDevelop({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetUbiThirdPartyAgreementsForServiceDevelopResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/third-party/ubi/agreements/for-service-develop/',
      query: {
        'vin': vin,
      },
    });
  }
}
